import { Get } from "axios/AxiosFunctions";
import SideBarSkeleton from "components/Core/SideBarSkeleton";
import DashboardCard from "components/DashboardCard";
import DashboardPieChart from "components/PieChart";
import ProgressBarList from "components/ProgressBarList";
import Skeleton from "components/Skeleton";
import { BaseURL } from "config/apiUrl";
// import { generateColorFromString } from "helper/HelperFunction";
import { useEffect, useState } from "react";
import { PiHandWavingFill } from "react-icons/pi";
import { useSelector } from "react-redux";
import classes from "./Statistics.module.css";

export default function Statistics() {
  const [loading, setLoading] = useState(false);
  const [statsData, setStatsData] = useState([]);
  const { access_token } = useSelector((state) => state?.authReducer);

  const getData = async () => {
    return;
    setLoading("get-data");
    const url = BaseURL("events/stats");
    const response = await Get(url, access_token);
    if (response !== undefined) {
      const mappedCategories = response?.data?.data?.categories?.map(
        (item) => ({
          ...item,
          // color: generateColorFromString(item.name),
          value: item.percentage,
        })
      );

      setStatsData({ ...response?.data?.data, categories: mappedCategories });
    }
    setLoading(false);
  };

  useEffect(() => {
    // getData();
  }, []);

  return (
    <SideBarSkeleton
      headerHeading={"Reporting/Statistics"}
      icon={<PiHandWavingFill />}
    >
      {/* <div className={classes.statistics_page_container}>
        <div className={classes.statistics_header_card}>
          {loading === "get-data" ? (
            <>
              {Array(3)
                .fill()
                .map((_, index) => (
                  <Skeleton
                    key={index}
                    width={300}
                    height={170}
                    variant="rounded"
                  />
                ))}
            </>
          ) : (
            <>
              {statsData?.types?.map((item, index) => (
                <DashboardCard key={index} data={item} index={index} />
              ))}
            </>
          )}
        </div>
        <div className={classes.statistics_main_container}>
          <h1>
            {loading === "get-data" ? (
              <Skeleton width={200} height={40} />
            ) : (
              "Statistics"
            )}
          </h1>
          <div className={classes.statistics_container}>
            <div className={classes.circle_chart}>
              {loading === "get-data" ? (
                <Skeleton width={300} height={300} variant="circular" />
              ) : (
                <DashboardPieChart data={statsData?.categories} />
              )}
            </div>
            <div className={classes.progress_bar}>
              {loading === "get-data" ? (
                Array(5)
                  .fill()
                  .map((_, index) => (
                    <Skeleton key={index} width={"100%"} height={30} />
                  ))
              ) : (
                <ProgressBarList data={statsData?.categories} />
              )}
            </div>
          </div>
        </div>
      </div> */}
    </SideBarSkeleton>
  );
}
